<template>
  <div class="toggle-open">
    <span class="when-opened">
      <i class="flaticon-down-arrow-2 icon-14 ml-1"></i>
    </span>
    <span class="when-closed">
      <i class="flaticon-down-arrow-2 icon-14 ml-1"></i>
    </span>
  </div>
</template>

<script>
export default {
  name: "min-open-colose"
};
</script>

<style >
.toggle-open {
  display: inline-block;
}
.collapsed .toggle-open > .when-opened,
:not(.collapsed) > .toggle-open .when-closed {
  display: none;
}
.when-opened i {
  transform: scale(-1, -1);
  display: inline-block;
}
</style>


// WEBPACK FOOTER //
// src/components/min-component/open-colose.vue